:host {
  padding: 0;
  width: 100%;
  font-size: 1rem;
  background-color: var(--sdx-color-aluminum);
  box-shadow: -1px -1px 2px 0 rgba(0, 0, 0, 0.15);
  position: relative;
  display: block;

  .notifications__container {
    background-color: var(--sdx-color-aluminum);
  }
}

.inlay.notifications {
  padding: 2rem 0 1rem;

  .no-activities-message {
    text-align: center;

    p {
      margin-bottom: 0;
      margin-top: 8px;
    }

    a {
      font-size: 18px;
      display: inline-block;
      margin-top: 8px;
      cursor: pointer;
    }
  }

  a {
    color: var(--sdx-color-int-blue);
  }

  .activities--loading {
    text-align: center;
    padding-bottom: 1.2rem;
  }
}
